import React from 'react';
import styled from 'styled-components';

const NextButton = (props) => {
    return (
        <Button
            onClick={props.clickHandler}
            bg={props.bg}
            lineColor={props.lineColor}
            color={props.color}
            sty={props.sty}
        >{props.text}</Button>
    );
};


const Button = styled.button`
    position:relative;
    width: 100%;
    margin-top: ${props => props.sty};
    background-color: ${props => props.bg};
    color: ${props => props.color};
    border-radius: 5px;
    height: 57.3px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-family: inherit;
    font-weight:bold;
    box-shadow: 5px 5px 2px 0px rgba(0,0,0,0.54);
    letter-spacing: 1px;

    & + & {
        margin-top: 21px;
    }

    &::after {
        content:"";
        position:absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
        border-right: 2px solid ${props => props.lineColor};
        border-bottom: 2px solid ${props => props.lineColor};
        border-bottom-right-radius: 5px;
        box-sizing:border-box;
        width: 98%;
        height: 95%;
    }
`;

export default NextButton;
